module.exports = __webpack_public_path__ + "img/section32.2f0c7dd3.png";